import { ResourcesConfig } from 'aws-amplify';
import { environment } from '../../../../environments/environment';

export const graphqlOptions: ResourcesConfig = {
    API: {
        GraphQL: {
            endpoint: environment.awsAppSync.graphqlEndpoint,
            region: 'us-east-1',
            defaultAuthMode: 'none'
        }
    }
};
